<template>
    <div>

        <!-- Table -->

        <trax-ui-card-plain-header-with-actions :title="title" :actions="card_actions" :bus="bus">
            <trax-training-competency-index-crud-table :bus="bus" :id="id" :type-code="typeCode" 
                :endpoint="endpoint" :hide-description="hideDescription" :edit-url="editUrl">
            </trax-training-competency-index-crud-table>
        </trax-ui-card-plain-header-with-actions>

        <!-- Editing modal -->

        <trax-ui-modal-default :id="id+'-edit'" :bus="bus">
            <trax-training-competency-index-crud-form :bus="bus" :id="id+'-edit'" :toastr-id="id+'-toastr'"
                :type-code="typeCode" :endpoint="endpoint">
            </trax-training-competency-index-crud-form>
        </trax-ui-modal-default>

        <!-- Delete confirm modal -->

        <trax-ui-modal-confirm :id="id+'-delete'" :title="this.lang.polaris.training.index_deletion" :bus="bus">
            {{ lang.polaris.training.confirm_delete_competency_index_q }}
        </trax-ui-modal-confirm>
            
        <!-- Search modal -->

        <trax-ui-modal-default :id="id+'-search'" :bus="bus" :title="lang.polaris.form.advanced_search">
            <trax-training-competency-index-crud-search :id="id" :bus="bus"></trax-training-competency-index-crud-search>
        </trax-ui-modal-default>

        <!-- Toastr -->

        <trax-ui-toastr :id="id+'-toastr'" :bus="bus" passed-label="1" no-progress="1">
        </trax-ui-toastr>
    
    </div>
</template>

<script>
    export default {
    
        props: {
            id: {default: 'trax-training-competency-index'},
            hideDescription: {default: false},
            typeCode: {default: 'standard-index'}
        },
    
        data: function() {
            return {
                lang: lang,
                competency_index_names: data.competency_index_names,
                competency_index_edit_routes: data.competency_index_edit_routes,
                endpoint: app_url+"polaris/api/front/competency-indexes",
                card_actions: [
                    { icon: 'search', event: this.id+'-search-open' },
                    { icon: 'add_box', event: this.id+'-edit-create' }
                ],
                bus: new Vue()
            }
        },

        computed: {
        
            title() {
                return this.competency_index_names[this.typeCode];
            },
        
            editUrl() {
                return this.competency_index_edit_routes[this.typeCode];
            }
        }


    }
</script>
